import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { AttendanceService } from '../../../../_services/attendance/attendance.service'
import { ApprovalService } from "src/app/_services/approval/approval.service";
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-short-leave-approval',
    templateUrl: './short-leave-approval.component.html',
    styleUrls: ['./short-leave-approval.component.scss']
})
export class ShortLeaveApprovalComponent implements OnInit {

    jsonData: any;
    tenantId: string;
    userId: number;
    date: any;
    currentUser: any;
    defaultColDef: any;
    rowSelection: any
    dataSource: any;
    public columnDefs: ColDef[];
    sampleGridFrameworkComponents: any;
    selectedCheckboxData = [];
    private api: GridApi;
    private columnApi: ColumnApi;
    rowData: any;
    getUserName: any;
    isAdmin: boolean;
    isTenantCustomised: boolean;
    isStatus: any;

    constructor(
        private storageService: LocalStorageService,
        private attendanceService: AttendanceService,
        private approvalService: ApprovalService,
    ) {
        {
            this.defaultColDef = {
                flex: 1,
                minWidth: 100,
                resizable: true,
            };
            this.rowSelection = 'multiple';
            this.columnDefs = this.createColumnDefs();

            this.sampleGridFrameworkComponents = {
                actionRowRendererComponent: ActionItemsGridRowRendererComponent
            };
        }
    }

    ngOnInit(): void {
        this.tenantId = this.storageService.get('tenantId');
        this.currentUser = JSON.parse(this.storageService.get('currentUser'));
        this.getShortLeaveApprovals();
    }

      async getAttendance(){
        let employeeId = this.currentUser.id;
        console.log("current user id:", employeeId);
        this.attendanceService.getAttendanceById(employeeId).subscribe((response: any) => {
          if(response.result && response.result.length > 0) {
            this.rowData = response.result.map(x => ({...x , day:this.getDays(x.attendanceDate)}));
          } else {
            this.rowData = [];
          }
        });
      }

    getShortLeaveApprovals() {
        let filterType = 'shortleaves';
        this.approvalService.getApprovals(filterType).subscribe((response: any) => {
            console.log(response, "response")
            this.rowData = response.shortLeaves;
            if (response.shortLeaves && response.shortLeaves.length > 0) {
                this.rowData = response.shortLeaves.map(x => ({ ...x, day: this.getDays(x.leaveDate) }));
            } else {
                this.rowData = [];
            }
        });
    }

    /**
    * get day from date
    * @param date 
    */
    getDays(date) {
        const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return weekday[new Date(date).getDay()];
    }

    onSelectionChanged(event) {
        this.selectedCheckboxData = [];
        let select = event.api.getSelectedNodes();
        for (let item of select) {
            this.selectedCheckboxData.push(item.data);
        }
    }

    // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
    onGridReady(params: any) {
        this.api = params.api;
        console.log('qqqq', this.api)
        this.columnApi = params.columnApi;
        this.api.sizeColumnsToFit();
    }

    isFirstColumn(params) {
        const displayedColumns = params.columnApi.getAllDisplayedColumns();
        const thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    }

    private createColumnDefs() {
        return [
            {
                headerName: "Date",
                field: "leaveDate", 'width': 200,
                filter: true,
                editable: false,
                sortable: true,
                headerCheckboxSelection: this.isFirstColumn,
                checkboxSelection: this.isFirstColumn,
            },
            {
                headerName: 'Days',
                field: 'day','width': 50,
                filter: true,
                editable: false,
                sortable: true
              },
              {
                headerName: 'Emp Id',
                field: 'localId','width': 50,
                filter: true,
                editable: false,
                sortable: true
              },
            {
                headerName: 'Employee',
                field: 'userName',
                // cellRenderer: (params) => {
                //     if (params.data.userId) {
                //         let name = params.data.userId + ' . ' + params.data.userName;
                //         return name;
                //     }
                //     else {
                //         return ''
                //     }
                // },
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'Short Leave Time',
                cellRenderer: (params) => {
                    if (params.data.firstHalf === true) {
                        return 'First Half'
                    }
                    else {
                        return 'Second Half'
                    }
                },
                filter: true,
                editable: false,
                sortable: true
            },
        ]
    }

    bulkApproveStatus() {
        let leaveId = [];
        for (let item of this.selectedCheckboxData) {
            leaveId.push(item.id);
        }
        let data = {
            ids: leaveId
        }
        window.alert("This is a backgroud activity and it will take few seconds, please refresh after sometime.");
        this.approvalService.approveShortLeaves(data).subscribe((response: any) => {
            console.log('Status Updated!!!');
        });
    }

    bulkRejectStatus() {
        let leaveId = [];
        for (let item of this.selectedCheckboxData) {
            leaveId.push(item.id);
        }
        let data = {
            ids: leaveId
        }
        window.alert("This is a backgroud activity and it will take few seconds, please refresh after sometime.");
        this.approvalService.rejectShortLeaves(data).subscribe((response: any) => {
            console.log('Status Updated!!!');
        });
    }
}